<template>
    <div class="entry-content">
        <div class="kvartalalley">


            <div class="test-wrapper">
                <a class="partnersky"
                   href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game">
                    <img :src="pathToImg+'kvartalalley-logo.png?v=6.0.0'" alt="" class="partnersky__img">
                    <div class="partnersky__desc">
                        Партнерський матеріал
                    </div>
                </a>
                <div class="test-bg" :class="{ active: question === 10 && redirect === false }"></div>
                <div class="test" :class="{ finished: question === 10 }">
                    <div class="progressbar" ref="progressbar"></div>
                    <div class="step" v-if="question>0 && question<=10">
                        <div class="step__back again" @click="doAgain()"
                             v-if="(question==10)">
                            <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                 viewBox="0 0 486.538 486.538" style="enable-background:new 0 0 486.538 486.538;">
                                <g>
                                    <g>
                                        <path d="M365.697,0l-13.923,13.923l67.76,67.76H132.139c-54.452,0-98.75,44.298-98.75,98.745v61.389h19.692v-61.389
			c0-43.591,35.466-79.053,79.058-79.053h287.394l-67.76,67.76l13.923,13.923l91.529-91.529L365.697,0z"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path d="M433.457,244.716v61.389c0,43.591-35.466,79.058-79.058,79.058H67.004l67.76-67.764l-13.923-13.923L29.313,395.01
			l91.529,91.529l13.923-13.923l-67.76-67.76h287.394c54.452,0,98.75-44.298,98.75-98.75v-61.389H433.457z"/>
                                    </g>
                                </g>
                            </svg>

                            <span>Зіграти ще раз</span>
                        </div>
                        <div class="step__number" v-if="(question<10)"><span>{{question}}</span> / 9</div>
                    </div>
                    <div class=" start" v-if="question === 0">
                        <div class="header">
                            <span>Інтерактивний конструктор:</span>
                            Збери житло своєї мрії!
                        </div>
                        <div class="start__info">
                            <img :src="pathToImg+'q12_start.svg?v=6.0.0'" alt="game" class="start__img">
                            <span class="desc">
                                Відповідай на питання та отримуй зображення житла мрії, створене за допомогою алгоритму.
                            </span>

                        </div>
                    </div>

                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 1" v-on:leave="leave">
                            <div class="header">
                                Де має розташовуватися ваше ідеальне житло?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] === 1 }">
                                        <!--<img src="../assets/questions/q12.svg?v=6.0.0" alt="" v-if="answer[0] === 0 " class="nohover">-->
                                        <img :src="pathToImg+'q12_hover.svg?v=6.0.0'"
                                             class="hover">
                                        <span>Я хочу жити у центрі міста, на відстані витягнутої руки до магазинів та ресторанів, і майже усюди пересуватися пішки.
                                    </span>
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] === 2 }">
                                        <!--<img src="../assets/questions/q11.svg?v=6.0.0" alt="" v-if="answer[0] === 0 " class="nohover">-->
                                        <span>Я хочу дихати свіжим повітрям й починати день з пробіжки у сосновому лісі. Оберу життя в передмісті.</span>
                                        <img :src="pathToImg+'q11_hover.svg?v=6.0.0'"
                                             class="hover">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>


                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 2">
                            <div class="header">
                                З цим визначилися. А якою буде територія вашого житлового комплексу?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1">
                                <span>
                                Це буде комплекс з закритою територією – парканом, охороною та камерами відеонагляду. Так я почуватимусь у безпеці.</span>
                                        <img :src="pathToImg+'q22_hover.svg?v=6.0.0'" class="hover">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2">
                                <span>
                                Територія мого будинку не буде огороджена. Сюди зможуть вільно проходити усі охочі.</span>
                                        <img :src="pathToImg+'q21_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 3">
                            <div class="header">
                                А яка архітектура вам більше до вподоби?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] === 1 }"
                                    >
                                        <img :src="pathToImg+'q32_hover.svg?v=6.0.0'">
                                        <!--<img :src="pathToImg+'q21_hover.svg?v=6.0.0'">-->
                                        <span>Оберу висотний будинок з якого відкриватиметься панорамний вид на місто. </span>

                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] === 2 }"
                                    >
                                        <img :src="pathToImg+'q31_hover.svg?v=6.0.0'">
                                        <span>
                               Більше подобається малоповерхова забудова, яка не тисне своїм об’ємом.</span>
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 4">
                            <div class="header">
                                Життя не обмежується простором всередині помешкання. Яке б ви хотіли мати подвір’я?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] === 1 }"
                                    >
                                <span>
                                У мене є авто, і я вже звик(ла) залишати його біля будинку – парковка під вікнами мене влаштовує.
                                    </span>
                                        <img :src="pathToImg+'q42_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] === 2 }"
                                    >
                                        <img :src="pathToImg+'q41_hover.svg?v=6.0.0'">
                                        <span>
                               Я хочу проводити вільний час на подвір’ї разом зі своєю родиною – це має бути громадський простір без авто.
                                </span>
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 5">
                            <div class="header">
                                А балкон має бути?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] === 1 }"
                                    >
                                <span>
                                Я люблю балкони – тут можна випити чашку кави, споглядаючи місто, а можна зберігати велосипед чи банку з солоними огірочками.</span>
                                        <img :src="pathToImg+'q52_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] === 2 }">
                                <span>
                               Я оберу будинок з великим панорамними вікнами без балконів – тоді фасад будинку завжди буде цілісним та красивим.</span>
                                        <img :src="pathToImg+'q51_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 6">
                            <div class="header">
                                Які сервіси робитимуть ваше життя щасливим – що обов’язково має знаходитися біля дому?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">

                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] > 0 }"

                                    >
                                <span>
                                Мені подобаються, коли на перших поверхах будинку розташовуються магазинчики, кафе та корисні сервіси.
                                </span>
                                        <img :src="pathToImg+'q61_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">

                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] > 0 }">
                                <span>
                                Важливо, щоб магазини й кафе розташовувалися неподалік – можна у сусідніх будівлях.</span>
                                        <img :src="pathToImg+'q62_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 7">
                            <div class="header">
                                А яка ще інфраструктура точно необхідна?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] > 0 }"
                                    >
                                <span>
                               Мені важливо, щоб було зручне транспортне сполучення, і можна було швидко дістатися будь-куди у місті на метро, трамваї чи автобусі.</span>
                                        <img :src="pathToImg+'q71_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] > 0 }">
                                        <img :src="pathToImg+'q72_hover.svg?v=6.0.0'">
                                        <span>
                                Хочу жити в тихому передмісті, всюди зможу доїхати на авто.</span>
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 8">
                            <div class="header">
                                Життя складається з дрібниць, а яким би ви хотіли бачити простір біля будинку?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">

                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] > 0 }">
                                <span>
                               До речі, ми з родиною ще не встигли подумати з цього приводу.
                                </span>
                                        <img :src="pathToImg+'q81_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">

                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] > 0 }">
                                <span>
                                 Я хочу, щоб простір був поділений для жителів різного віку. Зони з барбекю й гамаками – для дорослих, сучасні дитячі майданчики – для дітей, спортивні алеї для підлітків.
                                    </span>
                                        <img :src="pathToImg+'q82_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>
                    <transition name="slide-fade" mode="in-out">
                        <div class="question" v-if="question === 9">
                            <div class="header">
                                Можливо, ще маєте побажання щодо освітніх закладів для дітей?
                            </div>
                            <ol class="question_ans">
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(1)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 1"
                                        :class="{ active: answer[question-1] > 0 }">
                                <span>
                                Я хочу, щоб на території комплексу була соціальна інфраструктура – дитячий садок,
                                школа. А для занять спортом – фітнес-центр.</span>
                                        <img :src="pathToImg+'q91_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                                <transition name="question-fade" mode="in-out">
                                    <li @click="selectAnswer(2)"
                                        v-if="answer[question-1] === 0 || answer[question-1] === 2"
                                        :class="{ active: answer[question-1] > 0 }">
                                <span>
                                Ми вже обрали школу і дитсадок для дитини, й будемо відвозити ї на авто.</span>
                                        <img :src="pathToImg+'q92_hover.svg?v=6.0.0'">
                                    </li>
                                </transition>
                            </ol>
                        </div>
                    </transition>


                    <transition name="slide-fade" mode="in-out">
                        <div class="finish finish-render" v-if="question === 10 && redirect === true">
                            <span class="header">Генерується будинок мрії, будь ласка, зачекайте...</span>
                            <img :src="pathToImg+'q12_start.svg?v=6.0.0'" alt="game" class="start__img">

                        </div>
                        <div class="finish" v-if="question === 10 && redirect === false">
                            <span class="header">На картинці - ваш персональний будинок мрії, створений за допомогою відповідей на питання</span>
                            <p class="desc finishanswer" v-if="answer[0]=== 1 && answer[3]===1">
                                Ви справжній житель великого міста – постійно поспішаєте і цінуєте кожну хвилину.
                                Можливо, вам іноді потрібен відпочинок від потоку справ? В такому разі квартира у <a
                                    href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                    class="zhkkvartal" target="_blank" target="_blank">ЖК Krona Park 2</a> може стати
                                вашою інвестицією на майбутнє.
                            </p>
                            <p class="desc finishanswer" v-if="answer[0]=== 1 && answer[3]===2">
                                Ви любите місто за близькість до інфраструктури, але хотіли б жити у тиші й проводити
                                вільний час на свіжому повітрі. <a
                                    href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                    class="zhkkvartal" target="_blank" target="_blank">ЖК Krona Park 2</a>, хоча і
                                знаходиться у передмісті,
                                приємно здивує вас комфортною територією, якісною архітектурою та транспортною
                                зручністю, адже до метро всього 15 хвилин.
                            </p>
                            <p class="desc finishanswer" v-if="answer[0]=== 2 && answer[3]===1">
                                Ви цінуєте життя поряд з природою і хочете, щоб ваша автівка завжди була «під рукою»,
                                аби можна було виїхати в місто чи до озера.
                                Вам сподобається квартира з власною терасою у <a
                                    href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                    class="zhkkvartal" target="_blank">ЖК Krona Park 2</a>, оскільки він знаходиться
                                далеко від гучних магістралей та клопотів великого міста. А для авто знайдеться місце у
                                багаторівневому паркінгу :)</p>
                            <p class="desc finishanswer" v-if="answer[0]=== 2 && answer[3]===2">

                                Ви любите життя у затишному передмісті, цінуєте чисте повітря та радісні миті, проведені
                                разом з близькими. Зверніть увагу на <a
                                    href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                    class="zhkkvartal" target="_blank">ЖК Krona Park 2</a>, – вам сподобається квартира з
                                мальовничим видом на ліс.
                            </p>

                            <div class="finish__img">
                                <img :src="pathToImg+'z00.svg?v=6.0.0'">
                                <img :src="pathToImg+'land.svg?v=6.0.0'">
                                <img :src="pathToImg+'city.svg?v=6.0.0'" v-if="answer[0] === 1">
                                <img :src="pathToImg+'forest.svg?v=6.0.0'" v-if="answer[0] === 2">
                                <img :src="pathToImg+'building-big.svg?v=6.0.0'" v-if="answer[2] === 1">
                                <img :src="pathToImg+'building-small.svg?v=6.0.0'" v-if="answer[2] === 2">
                                <img :src="pathToImg+'balconies-big.svg?v=6.0.0'"
                                     v-if="answer[4] === 1 && answer[2] === 1">
                                <img :src="pathToImg+'balconies-small.svg?v=6.0.0'"
                                     v-if="answer[4] === 1 && answer[2] === 2">
                                <img :src="pathToImg+'ground-floor-shops.svg?v=6.0.0'" v-if="answer[5] === 1">
                                <img :src="pathToImg+'cars.svg?v=6.0.0'" v-if="answer[3] === 1">
                                <img :src="pathToImg+'green-without-cars.svg?v=6.0.0'" v-if="answer[3] === 2">
                                <img :src="pathToImg+'borders.svg?v=6.0.0'" v-if="answer[1] === 1">
                                <img :src="pathToImg+'public-transport.svg?v=6.0.0'" v-if="answer[6] === 1">
                                <img :src="pathToImg+'childplace.svg?v=6.0.0'" v-if="answer[7] === 1">
                                <img :src="pathToImg+'greens-without-childplace.svg?v=6.0.0'"
                                     v-if="answer[7] === 2">
                                <img :src="pathToImg+'school.svg?v=6.0.0'" v-if="answer[8] === 1">
                                <img :src="pathToImg+'greens-always.svg?v=6.0.0'">
                                <img :src="pathToImg+'separate-shops.svg?v=6.0.0'" v-if="answer[5] === 2">

                            </div>
                            <div class="social-media">
                                <span>Поділіться з друзями!</span>
                                <facebook :url=path scale="3"></facebook>
                                <twitter :url=path scale="3"></twitter>
                                <telegram :url=path scale="3"></telegram>
                            </div>

                            <div class="infozk">
                                <div class="desc">
                                    <p>
                                        <a href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                           class="zhkkvartal" target="_blank">ЖК Krona Park 2</a>
                                        знаходиться поруч з центром міста Бровари. 16 житлових будинків каскадної
                                        поверховості розташовані у декількох хвилинах від лісу та головної транспортної
                                        артерії міста. Будинки оточені природою, а на території є вся необхідна
                                        інфраструктура для активного життя.
                                    </p>
                                    <p>
                                        Комплекс спроєктований за форматом «місто в місті»: на його території
                                        передбачена школа, дитячий садок, паркінг, стадіон, медичний та фітнес-центр,
                                        променад з магазинами і кафе, зони для відпочинку з оригінальним ландшафтним
                                        дизайном. У житловому комплексі представлений широкий асортимент планувальних
                                        рішень, включно з квартирами з власними терасами та дворівневим плануванням.
                                        Опалення та гаряча вода потраплятимуть в будинки завдяки власній автономній
                                        котельні, що дозволить раціонально використовувати ресурси, підтримуючи
                                        комфортну температуру в приміщеннях у будь-який час року.
                                    </p>
                                    <div class="links-to-kvartal">
                                        <a href="https://www.facebook.com/kronapark2/ "><img
                                                :src="pathToImg+'fabook.png?v=6.0.0'"><span>Дивіться більше</span></a>
                                        <a href="http://m.me/kronapark2"><img :src="pathToImg+'messang.png'"><span>Пишіть нам</span></a>
                                    </div>
                                </div>
                                <a href="https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game "
                                   class="zhkkvartal" target="_blank" target="_blank"><img
                                        :src="pathToImg+'KA_Big_WM2.jpg?v=6.0.0'"></a>

                            </div>


                        </div>
                    </transition>
                    <button class="nextbutton startthegame" @click="nextQuestion()" :class="{'green':question === 10}"
                            v-if="question === 0 || question === 10">{{ buttonText }}
                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd"
                             clip-rule="evenodd">
                            <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import '../sass/main.scss';
    import 'reset-css';
    import {
        Facebook,
        Twitter,
        Telegram
    } from 'vue-socialmedia-share';

    // import SocialSharing from 'vue-social-sharing'
    let myPathToImg;
    if (document.getElementById('path')) {
        myPathToImg = document.getElementById('path').dataset.path;
    } else {
        myPathToImg = '/'
    }
    let answerBack = [];
    if (document.getElementById('path').dataset.answer) {
        answerBack = document.getElementById('path').dataset.answer.split('').map(Number);
    } else {
        answerBack = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    }


    export default {
        components: {
            Facebook,
            Twitter,
            Telegram
        },
        created() {
            let a = window.location.href;
            var arr = a.match(/dreamhome=(.*)/);
            if (arr != null) { // Did it match?
                this.question = 10;
            }
        },
        name: 'kvartalalley',
        data: function () {
            return {
                question: 0,
                arrfin: [],
                answer: answerBack,
                showButton: true,
                buttonText: "Почати гру",
                path: window.location.href,
                pathtoPhP: myPathToImg,
                pathToImg: myPathToImg + 'img/' || "/img/",
                progressBarWidth: 0,
                redirect: false
            }
        },
        watch: {
            question: function () {
                if (this.question > 0) {
                    this.buttonText = "Далі"
                }
                if (this.question === 9) {
                    this.buttonText = "Отримати результат тесту";
                    this.redirect = true;
                }
                if (this.question === 10) {
                    this.buttonText = "Дізнатись більше";
                    this.showButton = true;
                    if (this.redirect == true) {
                        let url = new URL(window.location.href);
                        let search_params = new URLSearchParams();
                        search_params.set('dreamhome', this.answer.join(""));
                        let new_url = url.origin.toString() + '' + url.pathname.toString() + '?' + search_params.toString();
                        window.location = new_url;
                    }
                }
                this.leave();
            },
        },
        methods: {
            selectAnswer: function (answer) {
                if (answer === 1) {
                    this.$set(this.answer, this.question - 1, 1)
                }
                if (answer === 2) {
                    this.$set(this.answer, this.question - 1, 2)
                }
                this.nextQuestion()

            },
            nextQuestion: function () {
                if (this.question < 10) {
                    this.question++;
                    this.progressBarWidth = this.progressBarWidth + 10;
                    this.$refs.progressbar.style.width = this.progressBarWidth + '%';
                } else {
                    window.location = 'https://2.kronapark.ua/?utm_source=hmarochos&utm_medium=cpc&utm_campaign=January_2020&utm_term=game';
                }

            },
            showHideButton: function () {
                if (this.question === 0 || this.question === 10) {
                    this.showButton = true;
                } else {
                    this.showButton = false
                }
            },
            leave: function () {
                window.scroll({
                    top: 0,
                    left: 0,
                });
            },
            doAgain: function () {
                let url = new URL(window.location.href);
                let new_url = url.origin.toString() + '' + url.pathname.toString();
                window.location = new_url;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
